export default __webpack_public_path__ + "static/media/background-light.88e5f2c4.jpg";